var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { AccordionSet, Accordion, Button, Checkbox, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { formatPublisherLabel } from "../utils/formatPublisherLabel";
import { RecekTextField, RecekSelection } from "./inputs";
import { DateRangeFilterAccordions } from "./DateRangeFilterAccordions";
export var TitlesFilters = function (_a) {
    var temporaryIdFilter = _a.temporaryIdFilter, temporaryNameFilter = _a.temporaryNameFilter, temporaryContributorFilter = _a.temporaryContributorFilter, temporaryProductNumberFilter = _a.temporaryProductNumberFilter, hasCommentForAgency = _a.hasCommentForAgency, temporaryDateRangeFilters = _a.temporaryDateRangeFilters, _b = _a.hasInvalidDateRange, hasInvalidDateRange = _b === void 0 ? false : _b, dateInputs = _a.dateInputs, publishers = _a.publishers, publishersLoading = _a.publishersLoading, selectedPublisher = _a.selectedPublisher, onIdFilterChange = _a.onIdFilterChange, onNameFilterChange = _a.onNameFilterChange, onContributorFilterChange = _a.onContributorFilterChange, onProductNumberFilterChange = _a.onProductNumberFilterChange, onPublisherFilterChange = _a.onPublisherFilterChange, onPublisherSearchInput = _a.onPublisherSearchInput, onToggleCommentForAgency = _a.onToggleCommentForAgency, _c = _a.showCommentForAgencyFilter, showCommentForAgencyFilter = _c === void 0 ? true : _c, onDateRangeFilterChange = _a.onDateRangeFilterChange, onApplyFilters = _a.onApplyFilters;
    var formatMessage = useIntl().formatMessage;
    var publisherOptions = useMemo(function () { return __spreadArray(__spreadArray([
        {
            value: "",
            label: formatMessage({
                id: "ui-br-agency.collectionsList.select.option.all",
            }),
        }
    ], (selectedPublisher &&
        selectedPublisher.sourceId &&
        selectedPublisher.name &&
        !publishers.some(function (p) { return p.sourceId === selectedPublisher.sourceId; })
        ? [
            {
                value: selectedPublisher.sourceId,
                label: formatPublisherLabel(selectedPublisher, formatMessage),
            },
        ]
        : []), true), publishers.map(function (publisher) { return ({
        value: publisher.sourceId || "",
        label: formatPublisherLabel(publisher, formatMessage),
    }); }), true); }, [publishers, selectedPublisher, formatMessage]);
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.title.accordion.label.name",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.title.filter.name.label", showLabel: false, value: temporaryNameFilter, onChange: function (e) {
                        return onNameFilterChange(e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.title.filter.placeholder.name",
                    }), marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.title.accordion.label.contributor",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.title.filter.contributor.label", showLabel: false, value: temporaryContributorFilter, onChange: function (e) {
                        return onContributorFilterChange(e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.title.filter.placeholder.contributor",
                    }), marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.title.accordion.label.productNumber",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.title.filter.productNumber.label", showLabel: false, value: temporaryProductNumberFilter, onChange: function (e) {
                        return onProductNumberFilterChange(e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.title.filter.placeholder.productNumber",
                    }), marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.filter.folioId.accordion.label",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-agency.filter.folioId.accordion.label", showLabel: false, value: temporaryIdFilter, onChange: function (e) {
                        return onIdFilterChange(e.target.value);
                    }, placeholder: formatMessage({
                        id: "ui-br-agency.filter.folioId.placeholder",
                    }), marginBottom0: true })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.title.accordion.label.publisher",
                }), separator: false },
                React.createElement(RecekSelection, { labelId: "ui-br-agency.title.accordion.label.publisher", showLabel: false, name: "publisher", value: selectedPublisher ? selectedPublisher.sourceId : "", asyncFilter: true, loading: publishersLoading, onFilter: onPublisherSearchInput, onChange: onPublisherFilterChange, dataOptions: publisherOptions, marginBottom0: true })),
            showCommentForAgencyFilter && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.title.accordion.label.commentForAgency",
                }), separator: false },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-agency.title.filter.commentForAgency.label",
                    }), checked: hasCommentForAgency, onChange: onToggleCommentForAgency }))),
            React.createElement(DateRangeFilterAccordions, { values: temporaryDateRangeFilters, onChange: onDateRangeFilterChange, invalidInputs: dateInputs.invalidInputs, onInvalidInputChange: dateInputs.setInputInvalid, inputsKey: dateInputs.inputsKey, labelIds: {
                    dateCreated: "ui-br-agency.title.accordion.label.dateCreated",
                    dateUpdated: "ui-br-agency.title.accordion.label.dateUpdated",
                }, idPrefix: "title-filter" })),
        React.createElement(Button, { type: "submit", disabled: hasInvalidDateRange, marginBottom0: true }, formatMessage({ id: "ui-br-agency.button.apply" }))));
};
